import { storage } from 'configs/firebase';
import { getDownloadURL, ref, uploadBytes, getBlob } from 'firebase/storage';

export const putFileToStorage = async (file: File, path: string) => {
  const storageRef = ref(storage, path);
  try {
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  } catch (e) {
    console.warn(e);
  }

  return '';
};
export const getFileFromURL = async (url: string): Promise<File | undefined> => {
  try {
    var storageRef = ref(storage, url);
    const blob = await getBlob(storageRef);
    const urlObj = new URL(url);
    const path = urlObj.pathname.split('/o/')[1];
    const fileName = decodeURIComponent(path).split('/').pop();
    const file = new File([blob], fileName!);
    return file;
  } catch (e) {
    console.warn(e);
  }
  return undefined;
};
